var path = 'areas/projects/action-template-fields/field-Checkbox.html';
var html = "<div> <input type=checkbox ng-model=vm.value name=\"checkbox_{{parameter.Name.replace('.', '_')}}\" ng-true-value=\"'True'\" ng-false-value=\"'False'\"> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/action-template-fields/field-Checkbox.html
// module id = 836
// module chunks = 1